import { render } from "./BackButton.vue?vue&type=template&id=b00dd4f8&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=ts"
export * from "./BackButton.vue?vue&type=script&lang=ts"

import "./BackButton.vue?vue&type=style&index=0&id=b00dd4f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b00dd4f8"

export default script